"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Checkbox_1 = tslib_1.__importDefault(require("@mui/material/Checkbox"));
const CheckBoxBase_1 = tslib_1.__importDefault(require("../internals/CheckBoxBase"));
const CheckboxField = props => {
    return (0, jsx_runtime_1.jsx)(CheckBoxBase_1.default, Object.assign({}, props, { Control: Checkbox_1.default }));
};
exports.default = CheckboxField;
